export const BAR_HEIGHT = 40;
